import { configureStore } from '@reduxjs/toolkit';
import authSlice from './reducers/authSlice';
import userSlice from './reducers/userSlice';
import visitorInfoSlice from './reducers/visitorInfoSlice';
import preferencesSlice from './reducers/preferences';

export const store = configureStore({
  reducer: {
    authSlice: authSlice,
    userSlice: userSlice,
    visitorInfoSlice: visitorInfoSlice,
    preferencesSlice: preferencesSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
